<template>
  <div
    class="bg-white rounded-xl shadow-lg flex flex-col flex-1 overflow-hidden mb-4 border"
  >
    <AutoComplete
      v-model="search"
      :suggestions="[]"
      @complete="selectConversation"
      :placeholder="$t('chat.search')"
      class="border border-solid m-3 rounded-lg w-11/12"
    />
    <div class="flex flex-col overflow-y-auto h-5/6">
      <RouterLink
        v-for="item in filteredConversations"
        :key="item.conversation_id"
        :class="[
          'flex items-center bg-white px-4 py-6 w-full hover:!bg-light-grey cursor-pointer border-b',
          $route.path.includes(item.uname) ? '!bg-light-grey' : 'bg-white',
        ]"
        :to="getbaseURL + '/Chat/' + item.uname"
      >
        <Avatar
          class="me-4"
          :image="item.avatar ? item.avatar : require('@/assets/user.png')"
          shape="circle"
          size="large"
        />
        <div class="w-10/12">
          <div class="flex justify-between items-center w-full">
            <p class="text-primary-900 text-sm font-semibold">
              {{ item.fullname }}
            </p>
            <div v-if="item.last_time" class="flex items-center gap-1 text-xs">
              <v-icon class="text-primary-500">mdi-clock-outline</v-icon>
              <p class="text-primary-500">
                {{ getConversationTime(item.last_time) }}
              </p>
            </div>
          </div>
          <div class="flex justify-between items-center w-full">
            <p
              :class="[
                'text-primary-900 text-sm mt-1',
                item.last_message ? '' : 'text-primary-400',
              ]"
            >
              {{ item.last_message ?? $t("chat.introduction_action") }}
            </p>
            <Badge
              v-if="item.not_read_msgs?.length > 0"
              :value="item.not_read_msgs.length"
              class="bg-primary-500 text-white text-xs font-semibold rounded-full mt-2"
            />
          </div>
        </div>
      </RouterLink>
    </div>
  </div>
</template>

<script>
import { Avatar, Badge, AutoComplete } from "primevue";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  components: {
    Avatar,
    Badge,
    AutoComplete,
  },
  props: {
    conversations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      uniqueConversations: [],
      filteredConversations: [],
      search: "",
    };
  },
  methods: {
    getConversationTime(lastTime, type) {
      const messageDay = moment.unix(+lastTime).format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(moment(today), "day");
      if (sameDayCond && type != 3) {
        return moment.unix(+lastTime).format("HH:mm");
      } else if (sameDayCond && type == 3) {
        return this.$t("chat.time.today");
      }
      if (moment(today).diff(moment(messageDay), "days") == 1) {
        return this.$t("chat.time.yesterday");
      }
      const weekEarlier = moment().add(-7, "days").format("YYYY-MM-DD");
      if (moment(weekEarlier).isBefore(moment(messageDay))) {
        return moment.unix(+lastTime).locale(this.currentLocal).format("dddd");
        // return moment.unix(+lastTime).format("dddd");
      }
      return messageDay;
    },
    selectConversation(event) {
      this.filteredConversations = this.uniqueConversations.filter((conv) => {
        return conv.fullname.toLowerCase().includes(event.query.toLowerCase());
      });
    },
  },
  computed: {
    ...mapGetters(["getbaseURL"]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  watch: {
    conversations: {
      immediate: true,
      handler(convs) {
        const seen = new Set();
        this.uniqueConversations = convs.filter((conv) => {
          if (!conv.uname) return true; // fallback if no ID
          if (seen.has(conv.uname)) return false;
          seen.add(conv.uname);
          return true;
        });
        this.filteredConversations = this.uniqueConversations;
      },
    },
    search: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.filteredConversations = this.uniqueConversations;
          return;
        }
      },
    },
  },
};
</script>

<style></style>
